<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title" v-if="this.idMerchant != null">
            Documentos do Cliente
          </h3>
          <h3 class="page-title" v-if="this.idMerchant == null">
            Documentos dos Clientes
          </h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Documentos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelMerchant }}
                    </th>
                    <th scope="col" class="border-0">{{ labelDocType }}</th>
                    <th scope="col" class="border-0">{{ labelStatus }}</th>
                    <th scope="col" class="border-0">{{ labelCreateDate }}</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(merchantDoc, index) in merchantDocs" :key="index">
                    <td></td>
                    <td class="text-left">{{ merchantDoc.Merchant.Name }}</td>
                    <td>{{ merchantDoc.MerchantDocType.Name }}</td>
                    <td>
                      <span
                        :class="[
                          GetSpanClass(merchantDoc.MerchantDocStatus.Code),
                        ]"
                        >{{ merchantDoc.MerchantDocStatus.Name }}</span
                      >
                    </td>
                    <td>{{ merchantDoc.CreatedDate | date }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('MerchantDoc', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="
                              GetMerchantDoc(merchantDoc.Id, true, false)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('MerchantDoc', 'Get')"
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : ''"
                            v-on:click.stop="
                              GetMerchantDoc(merchantDoc.Id, true, true)
                            "
                          >
                            <template v-if="loadingDownload">
                              <loader
                                :small="true"
                                :isLoading="loadingDownload"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingApprove ? 'disabled' : ''"
                            v-if="
                              merchantDoc.MerchantDocStatus.Code == '1' &&
                              $isAuthorize('MerchantDoc', 'UpdateStatus')
                            "
                            v-on:click.stop="
                              ConfirmUpdateMerchantDocStatus(
                                $event,
                                index,
                                true
                              )
                            "
                          >
                            <template v-if="loadingApprove">
                              <loader
                                :small="true"
                                :isLoading="loadingApprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-check mr-2"></i>
                              Aprovar
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingDisapprove ? 'disabled' : ''"
                            v-if="
                              merchantDoc.MerchantDocStatus.Code == '1' &&
                              $isAuthorize('MerchantDoc', 'UpdateStatus')
                            "
                            v-on:click.stop="
                              ConfirmUpdateMerchantDocStatus(
                                $event,
                                index,
                                false
                              )
                            "
                          >
                            <template v-if="loadingDisapprove">
                              <loader
                                :small="true"
                                :isLoading="loadingDisapprove"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-times mr-2"></i>
                              Reprovar
                            </template>
                          </a>

                          <a
                            v-if="$isAuthorize('MerchantDoc', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ConfirmDeleteMerchantDoc(
                                $event,
                                merchantDoc.MerchantDocType.Name,
                                merchantDoc.Merchant.Name,
                                merchantDoc.Id
                              )
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      merchantDocs == null ||
                      merchantDocs == undefined ||
                      merchantDocs.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormMerchantDoc"
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <nav v-if="!loadingModal" class="nav-steps" aria-label="breadcrumb">
        <ol
          style="background-color: #fff; padding: 0.75rem 0rem"
          class="breadcrumb"
        >
          <li class="breadcrumb-item">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 0)"
              :class="[pCurrentStep == 0 ? 'active' : '']"
            >
              Documento do Cliente
            </a>
          </li>
        </ol>
      </nav>

      <!-- Merchant Docs - Step: 0 -->
      <div v-if="!loadingModal && pCurrentStep === 0">
        <ValidationObserver ref="formValidation">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>{{ labelMerchant }}</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedFormValidation | showValidateError(invalid)"
                  v-model="infoMerchantDoc.Merchant.Id"
                  :disabled="true"
                >
                  <option :value="infoMerchantDoc.Merchant.Id" selected>
                    {{ infoMerchantDoc.Merchant.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>{{ labelDocType }}</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedFormValidation | showValidateError(invalid)"
                  v-model="infoMerchantDoc.MerchantDocType.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in merchantDocTypes"
                    v-bind:value="type.Code"
                    v-bind:key="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row v-if="isSeeing">
            <!-- CreatedDate -->
            <label>{{ labelCreateDate }}</label>
            <d-form-input
              type="text"
              v-bind:value="
                infoMerchantDoc.CreatedDate | date('DD/MM/YYYY - HH:mm')
              "
              readonly
            />
          </d-form-row>
          <!-- Url -->
          <d-form-row v-if="isCreating">
            <d-col md="12" class="form-group">
              <label>Arquivo</label>
              <b-form-file
                type="file"
                placeholder="Selecione ou arraste um arquivo"
                drop-placeholder="Solte o arquivo aqui"
                browse-text="Selecionar"
                accept="application/pdf"
                @change="SelectMerchantDocFile($event, true)"
                @input="SelectMerchantDocFile($event, false)"
              />
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="AddMerchantDocValidated()"
          v-if="!isSeeing || isCreating"
        >
          {{ isCreating == false ? "Salvar" : "Adicionar" }}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            class="form-control"
            placeholder="Id"
            type="text"
            v-model="filter.Id"
            :disabled="idMerchant != null"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            placeholder="CPF/CNPJ"
            :disabled="idMerchant != null"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeMerchantDocType" :value="null">
            <option :value="null" selected>{{ labelDocType }}</option>
            <option
              v-for="type in merchantDocTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeMerchantDocStatus" :value="null">
            <option :value="null" selected>{{ labelStatus }}</option>
            <option
              v-for="status in merchantDocStatus"
              v-bind:key="status.Code"
              v-bind:value="status.Code"
            >
              {{ status.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo documento"
      v-if="this.idMerchant != null && $isAuthorize('MerchantDoc', 'Add')"
      v-on:click="OpenMNewMerchantDoc()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { FileToBase64 } from "../../utils/fileUtils.js";
import { hasValue } from "../../utils/functions.js";
import dateField from "@/components/common/date-field";
export default {
  name: "merchant-docs",
  data: function () {
    return {
      idMerchant: null,
      countFilter: 0,
      filter: {
        Id: null,
        Identity: null,
        CodeMerchantDocType: null,
        CodeMerchantDocStatus: null,
      },
      validatedFormValidation: false,
      listPending: false,
      loadingDownload: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      loadingApprove: false,
      loadingDisapprove: false,
      pCurrentStep: 0,
      idMerchantDoc: 0,
      mSteps: ["merchantDoc"],
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      merchantDocs: [],
      merchantDocTypes: [],
      merchantDocStatus: [],
      merchants: [],
      infoMerchantDoc: {
        Merchant: {
          Id: this.idMerchant,
        },
        MerchantDocType: {
          Code: null,
        },
        Url: null,
      },
      merchantDocFile: null,
      isSeeing: false,
      isCreating: false,
      modalTitle: "Novo documento",
      labelMerchant: "Cliente",
      labelDocType: "Tipo de documento",
      labelCreateDate: "Data de criação",
      labelStatus: "Status",
    };
  },
  components: {
    dateField,
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListMerchantDoc(this.idMerchant);
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchantDoc(this.idMerchant);
    },
  },
  mounted() {
    if (
      this.$route.params.idMerchant !== null &&
      this.$route.params.idMerchant !== undefined
    ) {
      this.idMerchant = this.$route.params.idMerchant;
    }

    if (this.$route.query.listPending == "true") {
      this.listPending = true;
      this.filter.CodeMerchantDocStatus = "1";
    }

    if (this.idMerchant != null) this.GetMerchant();

    this.ListMerchantDoc(this.idMerchant);
    this.ListMerchantDocType();
    this.ListMerchantDocStatus();
  },
  methods: {
    SelectMerchantDocFile(obj, isEvent) {
      let file = null;
      if (isEvent) file = obj.target.files[0];
      else file = obj;
      if (file == null) return;

      if (file.type == "application/pdf") {
        this.merchantDocFile = file;
      } else {
        this.$makeToast(
          "O arquivo selecionado não é um PDF válido",
          "danger",
          "Documento do cliente"
        );
      }
    },
    AppendFormData(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormData(obj[property], fd, formKey);
          } else {
            if (typeof obj[property] === "number") {
              fd.append(formKey, obj[property].toString().replace(".", ","));
            } else {
              fd.append(formKey, obj[property]);
            }
          }
        }
      }

      return fd;
    },
    GetFormData(object) {
      return this.AppendFormData(object);
    },
    OpenMMerchantDoc: function () {
      this.validatedFormValidation = false;
      this.pCurrentStep = 0;
      this.$bvModal.show("mFormMerchantDoc");
    },
    OpenMNewMerchantDoc: function () {
      this.ResetInfoMerchantDoc();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Novo documento";
      this.OpenMMerchantDoc();
    },
    ResetInfoMerchantDoc: function () {
      this.infoMerchantDoc = {
        Merchant: {
          Id: this.merchants.Id,
          Name: this.merchants.Name,
        },
        MerchantDocType: {
          Code: null,
        },
        Url: null,
      };
    },
    AddMerchantDocValidated: function () {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid) {
          if (
            this.merchantDocFile != null &&
            this.merchantDocFile != undefined
          ) {
            this.AddMerchantDoc();
          } else {
            this.$makeToast(
              "Selecione um arquivo",
              "danger",
              "Documento do cliente"
            );
          }
        }
      });
    },
    AddMerchantDoc() {
      if (this.isCreating) {
        // Add
        this.loadingModal = true;
        let merchantDoc = this.infoMerchantDoc;
        merchantDoc = JSON.parse(JSON.stringify(merchantDoc));
        delete merchantDoc.Url;
        var formData = this.GetFormData(merchantDoc);
        formData.append(
          "File",
          this.merchantDocFile,
          this.merchantDocFile.name
        );
        this.$store
          .dispatch("AddMerchantDoc", formData)
          .then(() => {
            this.$makeToast(
              "Sucesso ao adicionar o documento",
              "success",
              "Documento do cliente"
            );
            this.ListMerchantDoc(this.idMerchant);
            this.$bvModal.hide("mFormMerchantDoc");
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível adicionar o documento",
              "danger",
              "Documento do cliente",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchantDoc(this.idMerchant);
    },
    ListMerchantDoc: function (idMerchant) {
      this.countFilter = 0;

      if (idMerchant !== null) {
        this.filter.Id = idMerchant;
      }

      if (this.filter.Id != null && this.filter.Id == "") this.filter.Id = null;

      if (hasValue(this.filter.Id)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.CodeMerchantDocType)) this.countFilter++;
      if (hasValue(this.filter.CodeMerchantDocStatus)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Id": this.filter.Id,
          "Object.Merchant.Identity": this.filter.Identity,
          "Object.MerchantDocType.Code": this.filter.CodeMerchantDocType,
          "Object.MerchantDocStatus.Code": this.filter.CodeMerchantDocStatus,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListMerchantDoc", { params: data })
        .then(
          (response) => {
            this.merchantDocs = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast(
              "Não foi possível listar os documentos",
              "danger",
              "Documentos dos Clientes",
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    ListMerchantDocType: function () {
      this.$store
        .dispatch("ListMerchantDocType", { params: {} })
        .then((response) => {
          this.merchantDocTypes = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de tipos de documentos",
            error
          );
        });
    },
    ListMerchantDocStatus: function () {
      this.$store
        .dispatch("ListMerchantDocStatus", { params: {} })
        .then((response) => {
          this.merchantDocStatus = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de status de documentos",
            error
          );
        });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function () {
      this.filter = {
        IdMerchant: null,
        CodeMerchantDocType: null,
        CodeMerchantDocStatus: this.listPending ? "1" : null,
      };
      this.ListMerchantDoc(this.idMerchant);
    },
    GetSpanClass: function (codeMerchantDocStatus) {
      let variation = "badge badge-warning";
      if (codeMerchantDocStatus == "2") {
        variation = "badge badge-success";
      } else if (codeMerchantDocStatus == "3") {
        variation = "badge badge-danger";
      }
      return variation;
    },
    GetMerchant: function () {
      this.loadingMerchant = true;
      this.$store
        .dispatch("GetMerchant", { id: this.idMerchant })
        .then((response) => {
          this.merchants = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter as informações do cliente",
            error
          );
        })
        .finally(() => {
          this.loadingMerchant = false;
        });
    },
    GetMerchantDoc: function (id, seeing, download) {
      if (download) this.loadingDownload = true;
      else this.loadingModal = true;
      if (!download) {
        if (seeing == true) {
          this.isSeeing = true;
          this.modalTitle = "Detalhes do documento";
        }
        this.isCreating = false;
        this.ResetInfoMerchantDoc();
        this.idMerchantDoc = id;
        this.OpenMMerchantDoc();
      }

      this.$store
        .dispatch("GetMerchantDoc", { id: id })
        .then((response) => {
          this.infoMerchantDoc = response;

          if (download && hasValue(response.Url)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Documento do cliente"
            );
            window.open(response.Url, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações do documento",
            "danger",
            "Documento do cliente",
            error
          );
        })
        .finally(() => {
          if (download) this.loadingDownload = false;
          else this.loadingModal = false;
        });
    },
    ConfirmDeleteMerchantDoc: function (e, nameDoc, nameMerchant, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${nameDoc} do cliente ${nameMerchant}?`,
        "Confirmar",
        this.DeleteMerchantDoc,
        i,
        nameDoc
      );
    },
    DeleteMerchantDoc: function (i, nameDoc) {
      this.$store
        .dispatch("DeleteMerchantDoc", { id: i })
        .then(() => {
          this.$makeToast(
            `${nameDoc} foi removido da sua lista de arquivos`,
            "success",
            "Arquivo"
          );
          this.ListMerchantDoc(this.idMerchant);
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o arquivo",
            error
          );
        });
    },
    ConfirmUpdateMerchantDocStatus: function (e, i, approve) {
      e.preventDefault();
      let merchantDoc = this.merchantDocs[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja ${
          approve ? "aprovar" : "reprovar"
        } este documento?`,
        "Confirmar",
        this.UpdateMerchantDocStatus,
        i,
        approve
      );
    },
    UpdateMerchantDocStatus: function (i, approve) {
      let codeMerchantDocStatus = "";
      let merchantDoc = this.merchantDocs[i];

      if (approve) {
        this.loadingApprove = true;
        codeMerchantDocStatus = "2";
      } else {
        this.loadingDisapprove = true;
        codeMerchantDocStatus = "3";
      }

      let infoMerchantDoc = {
        Id: merchantDoc.Id,
        MerchantDocStatus: {
          Code: codeMerchantDocStatus,
        },
      };
      this.$store
        .dispatch("UpdateMerchantDocStatus", infoMerchantDoc)
        .then(() => {
          this.$makeToast(
            "Sua solicitação foi processada com sucesso",
            "success",
            "Documentos dos Clientes"
          );
          this.ListMerchantDoc(this.idMerchant);
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao processar sua solicitação",
            error
          );
        })
        .finally(() => {
          if (approve) this.loadingApprove = false;
          else this.loadingDisapprove = false;
        });
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = {
        "Object.Merchant.Id": this.filter.Id,
        "Object.Merchant.Identity": this.filter.Identity,
        "Object.MerchantDocType.Code": this.filter.CodeMerchantDocType,
        "Object.MerchantDocStatus.Code": this.filter.CodeMerchantDocStatus,
      };
      this.$store
        .dispatch("ReportMerchantDoc", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente mais tarde.",
            "danger",
            "Geração de relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $(".dropdown-menu").removeClass("show");
            this.loadingReport = false;
          }, 250);
        });
    },
    GoToStep: function (e, stepToGo) {
      e.preventDefault();
      if (stepToGo < this.mSteps.length && stepToGo >= 0) {
        this.pCurrentStep = stepToGo;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/merchantDocs.vue